import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { Http } from '@angular/http';
import { RequestBuilder } from '../classes/request-builder';
import { Observable } from 'rxjs';
import * as Enum from '../utils/enums'

@Injectable({
  providedIn: 'root'
})
export class ScadenzarioService extends BaseService {
  /**
     * Costruttore
     * @param http Servizio di richieste HTTP 
     */
  constructor(http: Http) {
    super(http);
  }

  /**
   * get list of all scadenzario
   * @param reqBuilder data
   */
  getAllScadenzario(reqBuilder?: RequestBuilder): Observable<any> {
    let payload
    if(reqBuilder) {
      payload = reqBuilder
    }
    return this.doPost('documento/scadenzario', payload, Enum.CONTENT_TYPE_ENUM.APPLICATION_JSON)
  }  
}